import React, {useEffect, useState} from 'react';
import '../style/welcome_page.scss';
import {googleServer} from "../commons/commonVariable";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import useSessionRedirect from "../commons/commonHook";

const WelcomePage = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>();
    const [responseCode, setResponseCode] = useState<number>();

    useSessionRedirect();
    const exportSpreadsheet = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(googleServer + '/createSpreadSheet', {
                method: 'POST',
                credentials: 'include', // Include cookies
            });
            if (response.status === 201) {
                setIsModalOpen(true);
                setResponseCode(201);
            } else if(response.status === 400) {
                setIsModalOpen(true);
                setResponseCode(400);
            }
        } catch (error) {
            console.error("Error exporting spreadsheet:", error);
        } finally {
            setIsLoading(false); // Stop loading state
        }
    }

    const handleLogout = async () => {
        try {
            const response = await fetch(googleServer + '/user/logout', {
                method: 'POST',
                credentials: 'include',
            });
            if (response.status === 201) {
                window.location.href = 'https://aemr4all.com/';
            }
        } catch (error) {
            console.error("Error while logging out:", error);
        }
    }

    return (
        <div>
            <button className="logout-button" onClick={handleLogout}>Logout</button>
            <div className="content-main-body">
                <h1>🖐️ Welcome!</h1>
                <p>When you click the button below, you will get your own EMR spreadsheet in your Google Drive.</p>
                <p>Now, it's time to get a free Electronic Health Record. Please press the button below!</p>
                <div className="export-container">
                    {isLoading ? (
                            <div className="spinner"></div>)
                        : (
                            <button className="export-button" onClick={exportSpreadsheet}>
                                Export Data
                            </button>)
                    }
                    <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                        <Box className="modal-box">
                            {renderModalContent(responseCode)}
                        </Box>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

const renderModalContent = (code?: number) => {
    switch (code) {
        case 201:
            return (
                <>
                    <Typography variant="h4" fontWeight="bold" mt={1}>Awesome!</Typography>
                    <Typography variant="body1" color="text.secondary" mt={1}>
                        You're ready to use your own EMR from your own Google Drive. <br />
                        Please click <a href="https://drive.google.com/">here</a> to see the extraordinary EMR.
                    </Typography>
                </>
            );
        case 400:
            return (
                <>
                    <Typography variant="h4" fontWeight="bold" mt={1} color="error">Export Limit Reached</Typography>
                    <Typography variant="body1" color="text.secondary" mt={1}>
                        You've already exported EMR 3 times. <br />
                        Please contact aemr4all@gmail.com if you'd like to reset your export count.
                    </Typography>
                </>
            );
        default:
            return (
                <>
                    <Typography variant="h4" fontWeight="bold" mt={1}>Error</Typography>
                    <Typography variant="body1" color="text.secondary" mt={1}>
                        Something went wrong. Please try again or contact aemr4all@gmail.com
                    </Typography>
                </>
            );
    }
};

export default WelcomePage;